import React from "react";

class TerminalInit extends React.Component {
  render() {
    return (
      <div>
        Hello World!
        <br />
        type <strong style={{ color: "red" }}>help</strong> for a list of
        commands
      </div>
    );
  }
}

export default TerminalInit;
